import { ReactNode } from 'react';

import { Box, Button, List, ListItem, ListItemText, Typography } from '@mui/material';

import UpgradeToPremiumButton from '@/components/UpgradeToPremium/UpgradeToPremiumButton';
import useUserDetails from '@/hooks/useUserDetails';
import ExportSettingsComponent from '@/pages/DataHub/Export/ExportSettings';

const ExportPreviewScreen = ({
  actionHeading,
  bulletPoints,
  previewImg,
  children,
  handlePrimaryButtonClick,
  primaryButtonLabel,
  secondaryButton,
  listFooter,
  showSettings = true,
  showMetadata = true
}: {
  actionHeading: string | undefined;
  bulletPoints: never[] | string[] | undefined;
  previewImg: string | undefined;
  children?: ReactNode;
  handlePrimaryButtonClick?: () => void;
  primaryButtonLabel?: string;
  secondaryButton?: ReactNode;
  listFooter?: ReactNode;
  showSettings?: boolean;
  showMetadata?: boolean;
}) => {
  const { isUserPremium, isUserExpired } = useUserDetails();
  return (
    <>
      <Box>
        <Box sx={{ p: 2 }}>
          <Typography fontSize={24}>{actionHeading}</Typography>
          <List>
            {bulletPoints?.map((option: string) => (
              <ListItem
                key={option}
                sx={{ p: 0 }}
              >
                <Box sx={{ backgroundColor: 'text.primary', width: 4, height: 4, mr: 1 }} />
                <ListItemText primary={option} />
              </ListItem>
            ))}
            {listFooter}
          </List>
          {showSettings && (
            <Box sx={{ display: 'flex', alignItems: 'center', position: 'relative' }}>
              <ExportSettingsComponent showMetadata={showMetadata} />
            </Box>
          )}
          {primaryButtonLabel && (
            <Box sx={{ mt: 2 }}>
              {isUserPremium && !isUserExpired ? (
                <Button
                  variant='contained'
                  onClick={handlePrimaryButtonClick}
                >
                  {primaryButtonLabel}
                </Button>
              ) : (
                <UpgradeToPremiumButton type='upgrade' />
              )}
              {secondaryButton}
            </Box>
          )}
        </Box>
        {children}
      </Box>
      {previewImg && (
        <Box
          alt={actionHeading}
          component='img'
          src={previewImg}
          sx={{ height: `100%` }}
        />
      )}
    </>
  );
};
export default ExportPreviewScreen;
